/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Social_TitleInputs */

const et_service_social_title = /** @type {(inputs: Service_Social_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sotsiaalmeedia haldus`)
};

const en_service_social_title = /** @type {(inputs: Service_Social_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social Media Management`)
};

/**
* | output |
* | --- |
* | "Social Media Management" |
*
* @param {Service_Social_TitleInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const service_social_title = /** @type {((inputs?: Service_Social_TitleInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Social_TitleInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_service_social_title(inputs)
	return en_service_social_title(inputs)
});